import { render, staticRenderFns } from "./PhysicalDimensionsDefault.vue?vue&type=template&id=3f5e4ba4&"
import script from "./PhysicalDimensionsDefault.vue?vue&type=script&lang=js&"
export * from "./PhysicalDimensionsDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../create-website/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports